// extracted by mini-css-extract-plugin
export default {"recommendedContainer":"Recommended_recommendedContainer__S4qin","title":"Recommended_title__bw6Xh"};